import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import { UtilityRate } from 'brain-data/model/utility-rate.model';
import {
  createUtilityRateSuccess,
  deleteUtilityRateSuccess,
  loadUtilityRates,
  loadUtilityRatesError,
  loadUtilityRatesSuccess,
  updateUtilityRateSuccess,
} from '../actions/utility-rate.action';

export default interface UtilityRateState {
  rates: UtilityRate[];
  loading: boolean;
  loaded: boolean;
  error?: HttpErrorResponse;
}

export const initialState: UtilityRateState = {
  rates: [],
  loading: false,
  loaded: false,
  error: undefined,
};

const sortByTypeThenFromDesc = (a: UtilityRate, b: UtilityRate) => {
  if (a.utilityType !== b.utilityType) return a.utilityType.localeCompare(b.utilityType);
  return b.validFrom.localeCompare(a.validFrom);
};

export const reducer = createReducer(
  initialState,

  on(loadUtilityRates, (state): UtilityRateState => ({ ...state, loading: true, error: undefined })),
  on(loadUtilityRatesSuccess, (state, { rates }): UtilityRateState => ({
    ...state,
    rates: [...rates].sort(sortByTypeThenFromDesc),
    loading: false,
    loaded: true,
  })),
  on(loadUtilityRatesError, (state, { error }): UtilityRateState => ({
    ...state,
    loading: false,
    error,
  })),

  on(createUtilityRateSuccess, (state, { rate }): UtilityRateState => ({
    ...state,
    rates: [...state.rates, rate].sort(sortByTypeThenFromDesc),
  })),

  on(updateUtilityRateSuccess, (state, { rate }): UtilityRateState => ({
    ...state,
    rates: state.rates.map(r => (r.id === rate.id ? rate : r)).sort(sortByTypeThenFromDesc),
  })),

  on(deleteUtilityRateSuccess, (state, { id }): UtilityRateState => ({
    ...state,
    rates: state.rates.filter(r => r.id !== id),
  })),
);
